<script setup>
import { Checkbox } from 'dashboard/components-next/polaris/ui/checkbox';
defineProps({
  label: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['change']);
const onChange = (id, value) => {
  emit('change', id, value);
};
</script>

<!-- Phase 9.5: the kit's checkboxes; emits (value, checked) as before. -->
<template>
  <fieldset class="m-0 grid gap-3 border-0 p-0">
    <legend class="mb-1 type-polaris-label">{{ label }}</legend>
    <label
      v-for="item in items"
      :key="item.id"
      :for="`checkbox-condition-${item.value}`"
      class="flex cursor-pointer items-start gap-3 type-polaris-body"
    >
      <Checkbox
        :id="`checkbox-condition-${item.value}`"
        :model-value="item.model"
        @update:model-value="checked => onChange(item.value, checked)"
      />
      {{ item.label }}
    </label>
  </fieldset>
</template>
